export default "__VITE_ASSET__DmdgSCOl__"